import { render } from "./TestWidget.vue?vue&type=template&id=3d17cb45&scoped=true"
import script from "./TestWidget.vue?vue&type=script&lang=js"
export * from "./TestWidget.vue?vue&type=script&lang=js"

import "./TestWidget.vue?vue&type=style&index=0&id=3d17cb45&scoped=true&lang=scss"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d17cb45"]])

export default __exports__